<div class="md:hidden w-full">
  <afcu-input [form]="form" [question]="questions[0]" (externalFunction)="selectEvent($event)"/>
</div>
<div class="flex flex-col gap-4 pt-4" >
  @if(this.fetchAvailabilities.availabilityRessource.isLoading()){
    <afcu-loading target="calendar"/>
  } @else {
    <div class="flex justify-between">
      <div class=" w-full md:w-9/12 lg:w-9/12">
        <afcu-input [form]="form" [question]="FormBranchStaff" (externalFunction)="selectEvent($event)"/>
      </div>
      <div class="hidden md:block w-1/6 ">
        <afcu-input [form]="form" [question]="questions[0]" (externalFunction)="selectEvent($event)"/>
      </div>
    </div>
    
    @if(isError ){
      <afcu-banner state="warning" [content]="errorBanner"/>
    }
    
    @if(matchingServiceFound) {
    <div class="flex gap-8">
      <div class="shadow p-4 flex flex-col gap-2 md:w-1/2 lg:w-1/2 h-fit ">
        <div class="flex gap-5 justify-center py-0.5">
          <button [class]="{ 'opacity-30': disableDate().prev }" [disabled]="disableDate().prev" (click)="changeMonth(false)">
            <img src="/icons/arrow/back-black.svg" class="h-5 w-5">
          </button>
          <div class="font-bold text-xs text-gray-900 h-full flex items-center justify-center">{{getText().calendar.months[calendarAvailabilityService.month()]}} {{calendarAvailabilityService.year()}}</div>
          <button [class]="{ 'opacity-30': disableDate().next }" [disabled]="disableDate().next" (click)="changeMonth(true)">
            <img src="/icons/arrow/forward-black.svg" class="h-5 w-5">
          </button>
        </div>
        <div>
          <div>
            <div class="flex justify-evenly items-center gap-0.5">
              @for (day of getText().calendar.days; track day) {
                <div class="text-xs text-gray-500 text-center font-semibold py-2 px-1 capitalize w-[calc(100%/7)]">{{day}}</div>
              }
            </div>
            <div class="flex flex-wrap justify-evenly items-center gap-0.5">
              @for (day of calendarAvailabilityService.items(); track day; let idx = $index) {
                <div 
                  [class.text-gray-400]="day.staffAvailability.length == 0"
                  [class.disable]="day.staffAvailability.length == 0"
                  [class.today]="calendarAvailabilityService.calendar().today.getDate() === day.day && calendarAvailabilityService.calendar().today.getMonth()+1 === day.month"
                  [class.selected]="(calendarAvailabilityService.daySelectedAvailability().date === day.day && day.staffAvailability.length > 0 && calendarAvailabilityService.daySelectedAvailability().month === day.month)"
                  [class]="(day.staffAvailability.length) ? 'hover:bg-afcu-navy-300 hover:text-black' : 'cursor-not-allowed'"
                  class="w-[calc((100%-14px)/7)] py-2 px-1 font-bold text-xs text-center cursor-pointer" (click)="checkAvailability(day)">
                    {{day.day}}
                </div>
              }
            </div>
          </div>
          
        </div>
      </div>
       <!--Desktop View!-->
      <div class="hidden md:flex md:flex-col md:w-1/2 md:gap-6">
        @if(calendarAvailabilityService.availableTimeSlot().morning.length || calendarAvailabilityService.availableTimeSlot().afternoon.length) {
         <!--Desktop Morning-->
          <div class=" text-gray-700 font-semibold flex flex-col gap-4">
            <div>{{getText().calendar.morning}}</div>
            <div class="flex flex-wrap gap-4">
              @for(time of calendarAvailabilityService.availableTimeSlot().morning; track time){
                <button type="button" class="bg-primary-100 rounded-md py-0.5 px-3 text-center text-primary-800 cursor-pointer" (click)="selectAvailability(convertTo12HourFormat(time.timeSlot))">{{convertTo12HourFormat(time.timeSlot)}}</button>
              } @empty {
                <div class="bg-gray-100 py-0.5 px-3 text-gray-900 italic">{{getText().calendar.none}}</div>
              }
            </div>
          </div>
          <!--Desktop Afternoon-->
          <div class=" text-gray-700 font-semibold flex flex-col gap-4">
            <div>{{getText().calendar.afternoon}}</div>
            <div class="flex flex-wrap gap-4">
              @for(time of calendarAvailabilityService.availableTimeSlot().afternoon; track time){
                <div class="bg-primary-100 rounded-md py-0.5 px-3 text-center text-primary-800 cursor-pointer" (click)="selectAvailability(convertTo12HourFormat(time.timeSlot))">{{convertTo12HourFormat(time.timeSlot)}}</div>
              } @empty {
                <div class="bg-gray-100 py-0.5 px-3 text-gray-900 italic">{{getText().calendar.none}}</div>
              }
            </div>
          </div>
        } @else {
          <div class="w-full flex items-center justify-center">
            <afcu-info reason="noavailability"/>
          </div>
        }
      </div>
       <!--Desktop View!-->
    </div>
  
    <div class="text-xs text-black">
      {{formatPipe.transform(getText().calendar.timeZone, { hourDiff: hourDiff, timezone: timezone})}}
    </div>

    <!--Mobile View!-->
<div class="md:hidden flex flex-col gap-8 justify-start">
  @if(calendarAvailabilityService.availableTimeSlot().morning.length || calendarAvailabilityService.availableTimeSlot().afternoon.length) {
  
    <!--Mobile Morning-->
    <div class="text-gray-700 font-semibold flex flex-col gap-2">
      <div>{{getText().calendar.morning}}</div>
      <div class="flex flex-row flex-wrap gap-4">
        @for(time of calendarAvailabilityService.availableTimeSlot().morning; track time){
          <div class="bg-primary-100 rounded-md py-0.5 px-3 text-center text-primary-800 cursor-pointer"
               (click)="selectAvailability(convertTo12HourFormat(time.timeSlot))">
            {{convertTo12HourFormat(time.timeSlot)}}
          </div>
        } @empty {
          <div class="bg-gray-100 py-0.5 px-3 text-gray-900 italic">
            {{getText().calendar.none}}
          </div>
        }
      </div>
    </div>

    <!--Mobile Afternoon-->
    <div class="text-gray-700 font-semibold flex flex-col gap-2">
      <div>{{getText().calendar.afternoon}}</div>
      <div class="flex flex-row flex-wrap gap-4">
        @for(time of calendarAvailabilityService.availableTimeSlot().afternoon; track time){
          <div class="bg-primary-100 rounded-md py-0.5 px-3 text-center text-primary-800 cursor-pointer"
               (click)="selectAvailability(convertTo12HourFormat(time.timeSlot))">
            {{convertTo12HourFormat(time.timeSlot)}}
          </div>
        } @empty {
          <div class="bg-gray-100 py-0.5 px-3 text-gray-900 italic">
            {{getText().calendar.none}}
          </div>
        }
      </div>
    </div>

  } @else {
    <div class="w-full flex items-center justify-center">
      <afcu-info reason="noavailability"/>
    </div>
  }
</div>
<!--Mobile View!-->
    }
    
 @else {
    <div class="pt-15 pb-26 p-10 w-full flex items-center justify-center">
      <afcu-info reason="noserviceforlanguage"></afcu-info>
    </div>
  }

    }
</div>
